import {
	FETCH_ANNOUNCEMENTS,
	CLEAR_ANNOUNCEMENTS,
	CREATE_ANNOUNCEMENT,
	SEND_ANNOUNCEMENT,
	UPDATE_ANNOUNCEMENT,
	DELETE_ANNOUNCEMENT,
	ADD_GROUPS_TO_ANNOUNCEMENT,
	REMOVE_GROUPS_FROM_ANNOUNCEMENT,
} from '../actions/actionTypes';
import { checkForDuplicateItems } from '@/redux/util';
import { addGroups, removeGroups } from '@/redux/util/announcement.util';

const preState = [];

// Returns a new array sorted by send_at descending (latest send date first). Does not mutate.
const sortBySendAtDesc = list =>
	[...list].sort((a, b) => new Date(b.send_at).getTime() - new Date(a.send_at).getTime());

const announcementsReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = [...state];
	const { type, announcements, announcement, announcementID, groupIDs } = action;
	switch (type) {
		case FETCH_ANNOUNCEMENTS:
			return sortBySendAtDesc(announcements.nodes);
		case CLEAR_ANNOUNCEMENTS:
			return [];
		case CREATE_ANNOUNCEMENT:
			const alreadyExists = checkForDuplicateItems(stateDup, announcement.id);
			if (alreadyExists) return stateDup;
			return sortBySendAtDesc([...stateDup, announcement]);
		case SEND_ANNOUNCEMENT:
			return sortBySendAtDesc([...stateDup, { ...announcement, sent: true }]);
		case UPDATE_ANNOUNCEMENT:
			const updatedAnnouncements = stateDup.map(announce =>
				announce.id !== announcement.id ? announce : { ...announce, ...announcement }
			);
			return sortBySendAtDesc(updatedAnnouncements);
		case DELETE_ANNOUNCEMENT:
			return stateDup.filter(announce => announce.id !== announcementID);
		case ADD_GROUPS_TO_ANNOUNCEMENT:
			return stateDup.map(announce => {
				if (announce.id !== announcementID) return announce;
				else return addGroups(groupIDs, announce);
			});
		case REMOVE_GROUPS_FROM_ANNOUNCEMENT:
			return stateDup.map(announce => {
				if (announce.id !== announcementID) return announce;
				else return removeGroups(groupIDs, announce);
			});
		default:
			return stateDup;
	}
};

export default announcementsReducer;
